import React from 'react';
import { useStyletron } from 'baseui';
import { Controller } from 'react-hook-form';
import _get from 'lodash/get';
import Text from '../baseui/input/text';
import Label from '../baseui/input/Label';

const hydrateTimeInterval = (valueInMinutes: any) => {
	if (valueInMinutes) {
		const days = Math.floor(valueInMinutes / 1440);
		const hours = Math.floor((valueInMinutes % 1440) / 60);
		const minutes = Math.floor(valueInMinutes % 60);
		return {
			days: days === 0 ? undefined : days,
			hours: hours === 0 ? undefined : hours,
			minutes: minutes === 0 ? undefined : minutes
		};
	}

	return {};
};

const dehydrateTimeInterval = (days: any, hours: any, minutes: any) => {
	let valueInMinutes;

	if (days || hours || minutes) {
		valueInMinutes = (days || 0) * 1440 + (hours || 0) * 60 + (minutes || 0);
	}

	return valueInMinutes;
};

interface ITimeIntervalProps {
	name: any;
	control: any;
	defaultValue: any;
}

const TimeIntervalInput: React.FC<ITimeIntervalProps> = (props) => {
	const { name, control, defaultValue } = props;

	const [css] = useStyletron();

	return (
		<Controller
			render={({ field: { onChange, value } }) => {
				const { days, hours, minutes } = hydrateTimeInterval(value);

				const onDaysChange = (newDays: any) => {
					onChange(dehydrateTimeInterval(newDays, hours, minutes));
				};

				const onHoursChange = (newHours: any) => {
					onChange(dehydrateTimeInterval(days, newHours, minutes));
				};

				const onMinutesChange = (newMinutes: any) => {
					onChange(dehydrateTimeInterval(days, hours, newMinutes));
				};

				return (
					<div className={css({ display: 'flex', gap: '20px' })}>
						<div className={css({ display: 'flex', gap: '10px' })}>
							<Text {...props} value={days} onChange={onDaysChange} type='number' />
							<Label label='days' />
						</div>
						<div className={css({ display: 'flex', gap: '5px' })}>
							<Text {...props} value={hours} onChange={onHoursChange} type='number' />
							<Label label='hours' />
						</div>
						<div className={css({ display: 'flex', gap: '5px' })}>
							<Text {...props} value={minutes} onChange={onMinutesChange} type='number' />
							<Label label='minutes' />
						</div>
					</div>
				);
			}}
			control={control}
			name={name}
			defaultValue={defaultValue && hydrateTimeInterval(_get(defaultValue, ['field', ...defaultValue.path]))}
		/>
	);
};

export default TimeIntervalInput;
